import React, { useEffect, useState } from "react";
// import { randomMsgFn } from "../logic";
import { useSelector, useDispatch } from "react-redux";
import { saveAnswerGpt } from "../../../../features/mobile/cancerGptSlice";

const GPTAnswer = ({ question, cancerQ }) => {
  const { loginInfo } = useSelector((state) => state.commonApp);
  const dispatch = useDispatch();

  const [msg, setMsg] = useState("Generating response...");
  const [state, setState] = useState(false);

  // Function to convert URLs in text to clickable links
  const renderTextWithLinks = (text) => {
    if (!text) return null;

    // Split text by newlines to preserve formatting
    const lines = text.split('\n');

    return lines.map((line, lineIndex) => {
      // Regular expression to match URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = line.split(urlRegex);

      return (
        <React.Fragment key={lineIndex}>
          {parts.map((part, index) => {
            // If part matches URL pattern, render as link
            if (part.match(urlRegex)) {
              return (
                <a
                  key={index}
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline hover:text-blue-800"
                >
                  {part}
                </a>
              );
            }
            // Otherwise render as text
            return <span key={index}>{part}</span>;
          })}
          {lineIndex < lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };
  //   const loadingSpan =
  //     "inline-block w-[6px] h-[6px] bg-gray_160 rounded-[50%] animate-[gptloadingg_1s_linear_infinite] bg-black ";

  useEffect(() => {
    // GPT response is triggered each time a question comes in
    setMsg("Generating response");
    setState(false);
    onSaveAnswer();
    // eslint-disable-next-line
  }, [question]);

  const onSaveAnswer = () => {
    dispatch(
      saveAnswerGpt({
        userId: loginInfo.userId,
        question: question,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.ok) {
          //   console.log(res, "res");
          //   console.log(res.answer, "res");
          setState(true);
          setMsg(res.answer);
          // console.log(res.answer, "answer");
        } else {
          //   console.log(res, "failure res");
          setState(true);
          setMsg("Temporary error. Please try asking again.");
          //   toast(
          //     <p>{res.error}</p>,
          //     toastCommonProps("bottom-center", "toast_alert", 1000)
          //   );
        }
      })
      .catch((err) => {
        console.log(err);
        setState(true);
        setMsg("Temporary error. Please try asking again.");
      });
  };
  return (
    <>
      <div className="mx-6 mb-[124px] mt-4">
        <div className="mr-[-1px] h-min grow rounded-2xl bg-[#E8ECFF] p-4">
          <div className="flex text-left break-words text-body2_500l text-gray_180">
            <div className="flex-1">
              {state ? renderTextWithLinks(msg) : <span>{msg}</span>}
            </div>
            {/* tailwind로 변환 */}
            {/* 답변오기까지의 시간동안 말줄임표에 애니메이션을 적용해 보여줌 */}
            {/* className={"flex  " + (state === false ? "gptloading" : "")} */}
            {/* <div className="flex  ml-[10px] justify-center items-center  last:delay-[5000ms]">
              <span className={`${loadingSpan}  delay-75`}></span>
              <span className={`${loadingSpan}  mx-[10px] delay-100`}></span>
              <span className={`${loadingSpan} delay-1000`}></span>
            </div> */}
            <div className={"flex  " + (state === false ? "gptloading" : "")}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Source & Medical Disclaimer Section - Only show when response is ready */}
          {state && (
            <div className="mt-4 pt-4 border-t border-gray-300">
              <div className="text-xs text-gray-600">
                <p className="font-semibold mb-2">Source & Medical Disclaimer:</p>
                <p className="mb-1">This information is generated by OpenAI's ChatGPT, an AI language model.</p>
                <p className="font-semibold mb-2">Important: This information is for educational purposes only and should not replace professional medical advice. Always consult with qualified healthcare providers for medical decisions.</p>
                <p className="mb-1">For reliable medical information, visit:</p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>
                    <a href="https://www.cancer.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800">
                      National Cancer Institute (NCI)
                    </a>
                  </li>
                  <li>
                    <a href="https://www.cancer.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800">
                      American Cancer Society (ACS)
                    </a>
                  </li>
                  <li>
                    <a href="https://www.who.int/health-topics/cancer" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800">
                      World Health Organization (WHO) - Cancer
                    </a>
                  </li>
                  <li>
                    <a href="https://www.nccn.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800">
                      National Comprehensive Cancer Network (NCCN)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GPTAnswer;
